module.exports = __webpack_public_path__ + "img/admin-status-bar-lit.412a0e1c.svg";